import GeneralInformation from "@/services/GeneralInformation";

export default {
  namespaced: true,

  state: () => ({
    logo: null,
    login_vector: null,
    primary_color: null,
    loaded: false, // 🔑 important
  }),

  mutations: {
    SET_SYSTEM_INFO(state, payload) {
      state.logo = payload.logo;
      state.login_vector = payload.login_vector;
      state.primary_color = payload.primary_color;
      state.loaded = true;
    },
  },

  actions: {
    async fetchSystemInfo({ state, commit }) {
      // Prevent refetch
      if (state.loaded) return;

      try {
        // Replace with your API
        const response = await GeneralInformation.fetchGeneralInformation();
        const data = response.data;

        commit("SET_SYSTEM_INFO", {
          logo: data.logo,
          login_vector: data.login_vector,
          primary_color: data.primary_color,
        });
      } catch (error) {
        console.error("Failed to load system info", error);
      }
    },
  },

  getters: {
    systemLogo: (state) => state.logo,
    loginVector: (state) => state.login_vector,
    primaryColor: (state) => state.primary_color,
  },
};
